export const option_sex = {
  DE: [
    { label: "Mann", value: "mann" },
    { label: "Frau", value: "frau" },
  ],
  EN: [
    { label: "Male", value: "mann" },
    { label: "Female", value: "frau" },
  ],

  FR: [
    { label: "Homme", value: "mann" },
    { label: "Femme", value: "frau" },
  ],
};

export const option_age = {
  DE: [
    { label: "0 - 19", value: "0_19" },
    { label: "20 - 24", value: "20_24" },
    { label: "25 - 30", value: "25_30" },
    { label: "31 - 34", value: "31_34" },
    { label: "35 - 44", value: "35_44" },
    { label: "45 - 49", value: "45_49" },
    { label: "50 - 54", value: "50_54" },
    { label: "55 - 64/65", value: "55_65" },
    { label: "65/66 - 69 (mit BVG Sparen)", value: "65_69_mit_BVG" },
    { label: ">65/66 (ohne BVG Sparen)", value: "65_plus_ohne_BVG" },
  ],
  EN: [
    { label: "0 - 19", value: "0_19" },
    { label: "20 - 24", value: "20_24" },
    { label: "25 - 30", value: "25_30" },
    { label: "31 - 34", value: "31_34" },
    { label: "35 - 44", value: "35_44" },
    { label: "45 - 49", value: "45_49" },
    { label: "50 - 54", value: "50_54" },
    { label: "55 - 64/65", value: "55_65" },
    { label: "65/66 - 69 (incl. BVG savings)", value: "65_69_mit_BVG" },
    { label: ">65/66 (BVG savings excl.)", value: "65_69_mit_BVG" },
  ],
  FR: [
    { label: "0 - 19", value: "0_19" },
    { label: "20 - 24", value: "20_24" },
    { label: "25 - 30", value: "25_30" },
    { label: "31 - 34", value: "31_34" },
    { label: "35 - 44", value: "35_44" },
    { label: "45 - 49", value: "45_49" },
    { label: "50 - 54", value: "50_54" },
    { label: "55 - 64/65", value: "55_65" },
    { label: "65/66 - 69 (avec épargne LPP)", value: "65_69_mit_BVG" },
    { label: ">65/66 (sans épargne LPP)", value: "65_plus_ohne_BVG" },
  ],
};

export const option_vacation = {
  DE: [
    { label: "4 Wochen", value: "4_wochen" },
    { label: "5 Wochen", value: "5_wochen" },
    { label: "5.6 Wochen", value: "5.6_wochen" },
    { label: "6 Wochen", value: "6_wochen" },
    { label: "7 Wochen", value: "7_wochen" },
    { label: "8 Wochen", value: "8_wochen" },
  ],
  EN: [
    { label: "4 Weeks", value: "4_wochen" },
    { label: "5 Weeks", value: "5_wochen" },
    { label: "5.6 Weeks", value: "5.6_wochen" },
    { label: "6 Weeks", value: "6_wochen" },
    { label: "7 Weeks", value: "7_wochen" },
    { label: "8 Weeks", value: "8_wochen" },
  ],
  FR: [
    { label: "4 Semaines", value: "4_wochen" },
    { label: "5 Semaines", value: "5_wochen" },
    { label: "5.6 Semaines", value: "5.6_wochen" },
    { label: "6 Semaines", value: "6_wochen" },
    { label: "7 Semaines", value: "7_wochen" },
    { label: "8 Semaines", value: "8_wochen" },
  ],
};

export const option_target_pro = {
  DE: [
    { label: "pro Stunde", value: "pro_stunde" },
    { label: "pro Tag", value: "pro_tag" },
    { label: "pro Monat", value: "pro_monat" },
    { label: "pro Jahr", value: "pro_jahr" },
  ],
  EN: [
    { label: "per hour", value: "pro_stunde" },
    { label: "per day", value: "pro_tag" },
    { label: "per month", value: "pro_monat" },
    { label: "per year", value: "pro_jahr" },
  ],
  FR: [
    { label: "par heure", value: "pro_stunde" },
    { label: "par jour", value: "pro_tag" },
    { label: "pro mois", value: "pro_monat" },
    { label: "pro an", value: "pro_jahr" },
  ],
};

export const option_suva = {
  DE: [
    { label: "H - Industrie", value: "industry" },
    { label: "I - Uhren und Mikrotechnik", value: "tech" },
    { label: "J - Dienstleistungen (ohne Büro)", value: "services" },
    { label: "K - Transport und Logistik", value: "transport" },
    { label: "L - Facility Services", value: "facility" },
    { label: "P - Büro und Administration", value: "office" },
    { label: "Q - Finanz und Informatik", value: "finance" },
  ],
  EN: [
    { label: "H - Industrie", value: "industry" },
    { label: "I - Watches and Microtechnology", value: "tech" },
    { label: "J - Services (excluding office)", value: "services" },
    { label: "K - Transportation and Logistics", value: "transport" },
    { label: "L - Facility Services", value: "facility" },
    { label: "P - Office and Administration", value: "office" },
    { label: "Q - Finance and IT", value: "finance" },
  ],
  FR: [
    { label: "H - Industrie", value: "industry" },
    { label: "I - Watches and Microtechnology", value: "tech" },
    { label: "J - Services (excluding office)", value: "services" },
    { label: "K - Transportation and Logistics", value: "transport" },
    { label: "L - Facility Services", value: "facility" },
    { label: "P - Office and Administration", value: "office" },
    { label: "Q - Finance and IT", value: "finance" },
  ],
};


export const option_payrolling_fee = {
  DE: [
    { label: "In CHF pro Stunde", value: "CHF_pro_stunde" },
    { label: "In CHF pro Tag", value: "CHF_pro_tag" },
    { label: "In CHF pro Monat", value: "CHF_pro_monat" },
    { label: "In CHF pro Jahr", value: "CHF_pro_jahr" },
    { label: "In % des Bruttolohns", value: "perc_bruttolohn" },
    { label: "In % der Kundenrate", value: "perc_kundenrate" },
  ],
  EN: [
    { label: "In CHF per hour", value: "CHF_pro_stunde" },
    { label: "In CHF per day", value: "CHF_pro_tag" },
    { label: "In CHF per month", value: "CHF_pro_monat" },
    { label: "In CHF per year", value: "CHF_pro_jahr" },
    { label: "In % of gross salary", value: "perc_bruttolohn" },
    { label: "In % of bill rate", value: "perc_kundenrate" },
  ],
  FR: [
    { label: "En CHF par heure", value: "CHF_pro_stunde" },
    { label: "En CHF par jour", value: "CHF_pro_tag" },
    { label: "En CHF par mois", value: "CHF_pro_monat" },
    { label: "En CHF par an", value: "CHF_pro_jahr" },
    { label: "En % du salaire brut", value: "perc_bruttolohn" },
    { label: "En % du taux de clients", value: "perc_kundenrate" },
  ],
};

export const option_target_for = {
  DE: [
    { label: "Kundenrate", value: "bill_rate" },
    { label: "All-In Lohnkosten", value: "all_in_lohnkosten" },
    { label: "Bruttolohn", value: "bruttolohn" },
    { label: "Basislohn", value: "basissatz" },
    { label: "Nettolohn", value: "nettolohn" },
  ],
  EN: [
    { label: "Bill rate", value: "bill_rate" },
    { label: "All-In rate", value: "all_in_lohnkosten" },
    { label: "Gross salary", value: "bruttolohn" },
    { label: "Base salary", value: "basissatz" },
    { label: "Net salary", value: "nettolohn" },
  ],
  FR: [
    { label: "Taux de clients", value: "bill_rate" },
    { label: "Coûts salariaux all-in", value: "all_in_lohnkosten" },
    { label: "Salaire brut", value: "bruttolohn" },
    { label: "Salaire de base", value: "basissatz" },
    { label: "Salaire net", value: "nettolohn" },
  ],
};

export const option_payrolling_type = {
  DE: [
    { label: "in %", value: "percentage" },
    { label: "in CHF/h", value: "hour" },
  ],
  EN: [
    { label: "in %", value: "percentage" },
    { label: "in CHF/h", value: "hour" },
  ],
  FR: [
    { label: "en %", value: "percentage" },
    { label: "en CHF/h", value: "hour" },
  ],
};

export const defaultValues = {
  lan: "DE",
  sex: "mann",
  age: "55_65",
  bir: "01.01.1964",
  tgt: 100,
  tgp: "pro_stunde",
  tgf: "bruttolohn",
  hrw: 42,
  date: "",
  pen: 100,
  prf: "CHF_pro_stunde",
  prf_grade1: 4.0,
  prf_grade4: 5.0,
  prf_grade9: 6.0,
  pra: "CHF",
  vac: "5_wochen",
  suva: "office",
  msp: 0,
  soa: 0,
  bvg: null,
  ckt: false,
  ckh: false,
  chh: false,
  can: null,
  tar: null,
  chi: null,
  con: null,
  qsr: 0,
  qsm: 0,
  pro: [],
  contact: {
    name: "",
    vorname: "",
    adresse: "",
    postleitzahl: "",
    land: "Schweiz",
    telefon: "0041 ",
    email: "",
  },
};

export const option_haushalt = {};

export const option_canton = {
  DE: [
    { value: "AG", label: "Aargau" },
    { value: "AR", label: "Appenzell Ausserrhoden" },
    { value: "AI", label: "Appenzell Innerrhoden" },
    { value: "BL", label: "Basel-Land" },
    { value: "BS", label: "Basel-Stadt" },
    { value: "BE", label: "Bern" },
    { value: "FR", label: "Freiburg" },
    { value: "GE", label: "Genève" },
    { value: "GL", label: "Glarus" },
    { value: "GR", label: "Graubünden" },
    { value: "JU", label: "Jura" },
    { value: "LU", label: "Luzern" },
    { value: "NE", label: "Neuchâtel" },
    { value: "NW", label: "Nidwalden" },
    { value: "OW", label: "Obwalden" },
    { value: "SG", label: "St. Gallen" },
    { value: "SH", label: "Schaffhausen" },
    { value: "SZ", label: "Schwyz" },
    { value: "SO", label: "Solothurn" },
    { value: "TG", label: "Thurgau" },
    { value: "TI", label: "Ticino" },
    { value: "UR", label: "Uri" },
    { value: "VD", label: "Vaud" },
    { value: "VS", label: "Wallis" },
    { value: "ZG", label: "Zug" },
    { value: "ZH", label: "Zürich" },
  ],

  EN: [
    { value: "AG", label: "Aargau" },
    { value: "AR", label: "Appenzell Ausserrhoden" },
    { value: "AI", label: "Appenzell Innerrhoden" },
    { value: "BL", label: "Basel-Land" },
    { value: "BS", label: "Basel-Stadt" },
    { value: "BE", label: "Bern" },
    { value: "FR", label: "Freiburg" },
    { value: "GE", label: "Genève" },
    { value: "GL", label: "Glarus" },
    { value: "GR", label: "Graubünden" },
    { value: "JU", label: "Jura" },
    { value: "LU", label: "Luzern" },
    { value: "NE", label: "Neuchâtel" },
    { value: "NW", label: "Nidwalden" },
    { value: "OW", label: "Obwalden" },
    { value: "SG", label: "St. Gallen" },
    { value: "SH", label: "Schaffhausen" },
    { value: "SZ", label: "Schwyz" },
    { value: "SO", label: "Solothurn" },
    { value: "TG", label: "Thurgau" },
    { value: "TI", label: "Ticino" },
    { value: "UR", label: "Uri" },
    { value: "VD", label: "Vaud" },
    { value: "VS", label: "Wallis" },
    { value: "ZG", label: "Zug" },
    { value: "ZH", label: "Zürich" },
  ],
  FR: [
    { value: "AG", label: "Argovie" },
    { value: "AR", label: "Appenzell Rhodes-Extérieures" },
    { value: "AI", label: "Appenzell Rhodes-Intérieures" },
    { value: "BL", label: "Bâle-Campagne" },
    { value: "BS", label: "Bâle-Ville" },
    { value: "BE", label: "Bern" },
    { value: "FR", label: "Fribourg" },
    { value: "GE", label: "Genève" },
    { value: "GL", label: "Glaris" },
    { value: "GR", label: "Graubünden" },
    { value: "JU", label: "Jura" },
    { value: "LU", label: "Lucerne" },
    { value: "NE", label: "Neuchâtel" },
    { value: "NW", label: "Nidwald" },
    { value: "OW", label: "Obwalden" },
    { value: "SG", label: "St. Gallen" },
    { value: "SH", label: "Schaffhouse" },
    { value: "SZ", label: "Schwyz" },
    { value: "SO", label: "Soleure" },
    { value: "TG", label: "Thurgau" },
    { value: "TI", label: "Ticino" },
    { value: "UR", label: "Uri" },
    { value: "VD", label: "Vaud" },
    { value: "VS", label: "Valais" },
    { value: "ZG", label: "Zug" },
    { value: "ZH", label: "Zürich" },
  ],
};

export const option_tarif_external = {
  DE: [
    { label: "Alleinstehend", value: "A" },
    { label: "Verheiratete Alleinverdiener", value: "B" },
    { label: "Verheiratete Doppelverdiener", value: "C" },
  ],
  EN: [
    { label: "Unattached", value: "A" },
    { label: "Maried single income earner", value: "B" },
    { label: "Maried double income earner", value: "C" },
  ],
  FR: [
    { label: "Célibataire", value: "A" },
    { label: "Marié(e)s à revenu unique", value: "B" },
    { label: "Marié(e)s à double revenu", value: "C" },
  ],
};

export const option_tarif_internal = {
  DE: [
    { label: "(A) Alleinstehend", value: "A" },
    { label: "(B) Verheiratete Alleinverdiener", value: "B" },
    { label: "(C) Verheiratete Doppelverdiener", value: "C" },
    { label: "(E) Vereinfachtes Abrechnungsverfahren", value: "E" }, // prettier-ignore
    {label: "(F) Grenzgänger aus Italien mit ausserhalb der Schweiz erwerbstätigen Ehegatten",value: "F"}, // prettier-ignore
    {label: "(G) Ersatzeinkünfte ohne Ausbezahlung über die Arbeitgeber",value: "G"}, // prettier-ignore
    {label:"(H) Alleinstehende die mit Kindern/Unterstützungsbedürftige im gleichen Haushalt wohnen und deren Unterhalt zur Hauptsache bestreiten",value: "H"}, // prettier-ignore
    {label: "(L) Tarifcode A erfüllende Grenzgänger aus Deutschland",value: "L"}, // prettier-ignore
    {label: "(M) Tarifcode B erfüllende Grenzgänger aus Deutschland",value: "M" }, // prettier-ignore
    {label: "(N) Tarifcode C erfüllende Grenzgänger aus Deutschland",value: "N"}, // prettier-ignore
    {label: "(P) Tarifcode H erfüllende Grenzgänger aus Deutschland",value: "P"}, // prettier-ignore
    {label: "(Q) Tarifcode G erfüllende Grenzgänger aus Deutschland",value: "Q" }, // prettier-ignore
    {label: "(HE) Tarifcode für Verwaltungsräte",value: "HE" }, // prettier-ignore
    {label: "(ME) Tarifcode für Mitarbeiterbeteiligungen",value: "ME" }, // prettier-ignore
    {label: "(NO) Tarifcode im Falle einer Korrektur für Personen die fälschlicherweise an der Quelle besteuert wurden oder es fälschlicherweise nicht wurden",value: "NO" }, // prettier-ignore
    {label: "Tessin: (R) Tarifcode A erfüllende Grenzgänger aus Italien",value: "R" }, // prettier-ignore
    {label: "Tessin: (S) Tarifcode B erfüllende Grenzgänger aus Italien",value: "S" }, // prettier-ignore
    {label: "Tessin: (T) Tarifcode C erfüllende Grenzgänger aus Italien",value: "T" }, // prettier-ignore
    {label: "Tessin: (U) Tarifcode D erfüllende Grenzgänger aus Italien",value: "U" }, // prettier-ignore
    {label: "(SF) Tarifcode für Grenzgänger aus Frankreich nach der Sondervereinbarung der Kantone BE,BS, BL, JU, NE, SO, VD, VS",value: "SF" }, // prettier-ignore
    {label: "(PEL) Bezugsprovision elektronisch",value: "PEL" }, // prettier-ignore
    {label: "(PPA) Bezugsprovision Papier",value: "PPA" }, // prettier-ignore
    {label: "(MED) Höchstbetrag für das satzbestimmende Ehegatteneinkommen für den Tarifcode C (Code Medianwert)",value: "MED" }, // prettier-ignore
  ],
  EN: [
    { label: "(A) Unattached", value: "A" },
    { label: "(B) Maried single income earner", value: "B" },
    { label: "(C) Maried double income earner", value: "C" },

    { label: "(E) Simple accounting procedure", value: "E" }, // prettier-ignore
    {label: "(F) Cross-boarder commuters from Italy with a spouse that is employed outside of Switzerland",value: "F"}, // prettier-ignore
    {label: "(G) Substitute earnings without payment to employer",value: "G"}, // prettier-ignore
    {label:"(H) Unattached with children or a person of need living in the same household and who are the sole support",value: "H"}, // prettier-ignore
    {label: "(L) Cross-boarder commuters from Germany who fulfill tarifcode A requirements",value: "L"}, // prettier-ignore
    {label: "(M) Cross-boarder commuters from Germany who fulfill tarifcode B requirements",value: "M" }, // prettier-ignore
    {label: "(N) Cross-boarder commuters from Germany who fulfill tarifcode C requirements",value: "N"}, // prettier-ignore
    {label: "(P) Cross-boarder commuters from Germany who fulfill tarifcode H requirements",value: "P"}, // prettier-ignore
    {label: "(Q) Cross-boarder commuters from Germany who fulfill tarifcode G requirements",value: "Q" }, // prettier-ignore
    {label: "(HE) Tarifcode for board of directors members",value: "HE" }, // prettier-ignore
    {label: "(ME) Tarifcode employee participation",value: "ME" }, // prettier-ignore
    {label: "(NO) Tarifcode corrections in the case of wrongly taxing the person at the source or wrongly not taxing the person at the source",value: "NO" }, // prettier-ignore
    {label: "Tessin: (R)  Cross-boarder commuters from Italy who fulfill tarifcode A requirements",value: "R" }, // prettier-ignore
    {label: "Tessin: (S) Cross-boarder commuters from Italy who fulfill tarifcode B requirements",value: "S" }, // prettier-ignore
    {label: "Tessin: (T) Cross-boarder commuters from Italy who fulfill tarifcode C requirements",value: "T" }, // prettier-ignore
    {label: "Tessin: (U)  from Italy who fulfill tarifcode D requirements",value: "U" }, // prettier-ignore
    {label: "(SF) Cross-boarder commuters from France according to the special arrangement of the cantons BE,BS, BL, JU, NE, SO, VD, VS",value: "SF" }, // prettier-ignore
    {label: "(PEL) Provision electronic",value: "PEL" }, // prettier-ignore
    {label: "(PPA) Provision paper",value: "PPA" }, // prettier-ignore
    {label: "(MED) Maximum value for rate-determining income of spouse applied to Tarifcode C (Code Median value)",value: "MED" }, // prettier-ignore
  ],
  FR: [
    { label: "(A) Célibataire", value: "A" },
    { label: "(B) Marié(e), seul(e)", value: "B" },
    { label: "(C) Marié(e), double revenu", value: "C" },
    {label : "(E) Méthode de calcul simplifiée", value : "E" }, // prettier-ignore
    {label : "(F) Frontalier italien dont le conjoint exerce une activité lucrative en dehors de la Suisse",value : "F"}, // prettier-ignore
    {label : "(G) Revenus de remplacement non versés par les employeurs",value : "G"}, // prettier-ignore
    {label : "(H) Personnes seules vivant avec enfants à charge dont elles assurent l'essentiel du soutien",value : "H"}, // prettier-ignore
    {label : "(L) Travailleurs frontaliers d'Allemagne remplissant les conditions du code tarifaire A",value : "L"}, // prettier-ignore
    {label : "(M) Travailleurs frontaliers d'Allemagne remplissant les conditions du code tarifaire B",value : "M" }, // prettier-ignore
    {label : "(N) Travailleurs frontaliers d'Allemagne remplissant les conditions du code tarifaire C",value : "N"}, // prettier-ignore
    {label : "(P) Travailleurs frontaliers d'Allemagne remplissant les conditions du code tarifaire H",value : "P"}, // prettier-ignore
    {label : "(Q) Travailleurs frontaliers d'Allemagne remplissant les conditions du code tarifaire G",value : "Q" }, // prettier-ignore
    {label : "(HE) Code tarifaire pour les administrateurs",value : "HE" }, // prettier-ignore
    {label : "(ME) Code tarif pour les participations des salarié(e)s",value : "ME" }, // prettier-ignore
    {label : "(NO) Code de barème en cas de correction pour les personnes qui ont été imposées à la source à tort ou qui ne l'ont pas été à tort",value : "NO" }, // prettier-ignore
    {label : "Tessin : (R) Travailleurs frontaliers d'Italie remplissant les conditions du code tarifaire A",value : "R" }, // prettier-ignore
    {label : "Tessin : (S) Travailleurs frontaliers d'Italie remplissant les conditions du code tarifaire B",value : "S" }, // prettier-ignore
    {label : "Tessin : (T) Travailleurs frontaliers d'Italie remplissant les conditions du code tarifaire C",value : "T" }, // prettier-ignore
    {label : "Tessin : (U) Travailleurs frontaliers d'Italie remplissant les conditions du code tarifaire D",value : "U" }, // prettier-ignore
    {label : "(SF) Code tarifaire pour les frontaliers de France selon l'accord spécial des cantons BE,BS, BL, JU, NE, SO, VD, VS",value : "SF" }, // prettier-ignore
    {label : "(PEL) commission de perception électronique",value : "PEL" }, // prettier-ignore
    {label : "(PPA) Commission d'achat papier",value : "PPA" }, // prettier-ignore
    {label : "(MED) Revenu maximum de l'époux déterminant le taux pour le code tarifaire C (code valeur médiane)",value : "MED" }, // prettier-ignore
  ],
};

export const option_children = {
  DE: [
    { label: "0", value: "0" },
    { label: "1", value: "1" },
    { label: "2", value: "2" },
    { label: "3", value: "3" },
    { label: "4", value: "4" },
    { label: "5", value: "5" },
    { label: "6", value: "6" },
    { label: "7", value: "7" },
    { label: "8", value: "8" },
    { label: "9", value: "9" },
  ],
  EN: [
    { label: "0", value: "0" },
    { label: "1", value: "1" },
    { label: "2", value: "2" },
    { label: "3", value: "3" },
    { label: "4", value: "4" },
    { label: "5", value: "5" },
    { label: "6", value: "6" },
    { label: "7", value: "7" },
    { label: "8", value: "8" },
    { label: "9", value: "9" },
  ],
  FR: [
    { label: "0", value: "0" },
    { label: "1", value: "1" },
    { label: "2", value: "2" },
    { label: "3", value: "3" },
    { label: "4", value: "4" },
    { label: "5", value: "5" },
    { label: "6", value: "6" },
    { label: "7", value: "7" },
    { label: "8", value: "8" },
    { label: "9", value: "9" },
  ],
};

export const option_children_household = {
  DE: [
    { label: "Ja", value: true },
    { label: "Nein", value: false },
  ],
  EN: [
    { label: "Yes", value: true },
    { label: "No", value: false },
  ],
  FR: [
    { label: "Oui", value: true },
    { label: "Non", value: false },
  ],
};

export const option_confession = {
  DE: [
    { label: "andere", value: 0 },
    { label: "evangelisch", value: 1 },
    { label: "christ-katholisch", value: 2 },
    { label: "römisch-katholisch", value: 3 },
  ],
  EN: [
    { label: "other", value: 0 },
    { label: "evangelic", value: 1 },
    { label: "christian-catholic", value: 2 },
    { label: "roman-catholic", value: 3 },
  ],
  FR: [
    { label: "autres", value: 0 },
    { label: "évangélique", value: 1 },
    { label: "catholique-chrétienne", value: 2 },
    { label: "catholique-romaine", value: 3 },
  ],
};

export const required = {
  default: ["hrw", "stunden_pd", "tgt", "pen"],
  quell: ["can", "chi", "con", "tar"],
  tarCodeError: ["error"],
  age: ["birthday_format"],
  ferien_anspruch: ["ferien_anspruch"],
  form: [
    "name",
    "vorname",
    "adresse",
    "telefon",
    "postleitzahl",
    "land",
    "email",
    "stadt",
    "gdpr",
  ],
};
